import { Col, Layout, Row, theme } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import SideBar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../providers/AuthProvider";
import { useGetUserSuppliersQuery } from "../api/services/suppliers";
import { setSupplierId } from "../api/slices/authSlice";
// import { AuthContext } from "../../providers/AuthProvider";

// import { assets } from "../../assets";

const { Header, Content, Sider } = Layout;

const ProtectedLayout = () => {
  const dispatch = useDispatch();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [collapsed, setCollapsed] = useState(true);
  const { isAuthenticated, authState } = useContext(AuthContext);
  // const { authState, isAuthenticated } = useContext(AuthContext);

  const navigate = useNavigate();

  const { data } = useGetUserSuppliersQuery();

  useEffect(() => {
    // if (!authState?.supplier_id) {
    //   navigate("/select-supplier");
    // }
    if (data?.items?.length > 0) {
      dispatch(setSupplierId(data?.items?.[0]?.id));
    }

    return () => {};
  }, [dispatch, data]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Layout>
      <Header
        style={{
          padding: 0,
          background: colorBgContainer,
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 100,
          width: "100%",
          borderBottom: "1px solid rgba(0, 0, 0, 0.10)",
          height: "72px",
        }}
      >
        <TopBar />
      </Header>
      <Layout
        style={{
          paddingTop: "72px",
          zIndex: 0,
          background: "#F8F8F8",
          // backgroundImage: `url(${assets.backgroundImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          minHeight: "100vh",
        }}
      >
        <Sider
          width={230}
          collapsedWidth={68}
          // collapsible
          // onCollapse={(value) => setCollapsed(value)}
          onMouseEnter={() => setCollapsed(false)}
          onMouseLeave={() => setCollapsed(true)}
          collapsed={collapsed}
          theme="light"
          style={{
            position: "fixed",
            top: 72,
            left: 0,
            bottom: 0,
            zIndex: 2,
            height: `calc(100vh - 72px)`,
            boxShadow:
              "0px 12px 24px 0px rgba(0, 0, 0, 0.16), 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            boxSizing: "border-box",
            overflowY: "scroll",
          }}
        >
          <SideBar />
        </Sider>

        <Content
          style={{
            // paddingTop: "10px",
            zIndex: 0,
          }}
        >
          <Outlet />
          {/* <Outlet /> */}
          {/* {authState.authenticated && <Outlet />} */}
        </Content>
      </Layout>
    </Layout>
  );
};
export default ProtectedLayout;
